
import { TipoNotificacao } from "@/interfaces/INotificacao";
import { useStore } from "@/store";
import { computed,defineComponent } from "vue";

export default defineComponent({
    name: 'NotificacoesNotificacoes',
    data() {
      return{
        contexto:{
          [TipoNotificacao.SUCESSO]: 'is-success',
          [TipoNotificacao.ATENCAO]: 'is-warning',
          [TipoNotificacao.FALHA]: 'is-danger',
        }
      }
    },
    setup() {
      const store = useStore() 
      return {
        notificacoes: computed(() => store.state.notificacoes)
      }
    }
})
